var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.346656436
  }, /*#__PURE__*/React.createElement("g", {
    id: "Miscellaneous-Config--Collections",
    transform: "translate(-670.000000, -543.000000)",
    fill: "#808285",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info-Copy-5",
    transform: "translate(670.000000, 543.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1,4.5 L9.9,4.5 L9.9,6.3 L8.1,6.3 L8.1,4.5 Z M8.1,8.1 L9.9,8.1 L9.9,13.5 L8.1,13.5 L8.1,8.1 Z M9,0 C4.02943725,0 1.77635684e-15,4.02943725 1.77635684e-15,9 C1.77635684e-15,13.9705627 4.02943725,18 9,18 C13.9705627,18 18,13.9705627 18,9 C18,6.61305159 17.0517884,4.32386638 15.363961,2.63603897 C13.6761336,0.948211563 11.3869484,0 9,0 Z M9,16.2 C5.0235498,16.2 1.8,12.9764502 1.8,9 C1.8,5.0235498 5.0235498,1.8 9,1.8 C12.9764502,1.8 16.2,5.0235498 16.2,9 C16.2,10.9095587 15.4414307,12.7409069 14.0911688,14.0911688 C12.7409069,15.4414307 10.9095587,16.2 9,16.2 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b3fa6ea9.svg";
export { ForwardRef as ReactComponent };